import { CURRENCY } from '~/shared/config/constants'
import { MoveFundsType } from '~/shared/config/enums'
import { isNumber } from '~/shared/lib/utils'
import {
  Wrapper,
  DataWrapper,
  Comment,
  Description,
  Currency,
  Amount,
} from './styled'

type CardProps = {
  comment: string
  amount: number
  description?: string
  moveFundsType: MoveFundsType
  id: UniqueId
}

export function Card({
  comment,
  description,
  amount,
  moveFundsType,
  id,
}: CardProps) {
  return (
    <Wrapper data-testid={`card-${id}`}>
      <DataWrapper>
        <Comment data-testid='card-comment'>{comment}</Comment>
        {description && (
          <Description data-testid='card-description'>
            {description}
          </Description>
        )}
      </DataWrapper>
      <div>
        <Amount data-testid='card-amount'>
          {moveFundsType === MoveFundsType.COMING ? '+' : '-'}
          {isNumber(amount) ? amount.toLocaleString() : amount}&#x20;
          <Currency data-testid='card-currency'>{CURRENCY}</Currency>
        </Amount>
      </div>
    </Wrapper>
  )
}
